import { render, staticRenderFns } from "./DoctorAgentPanel.vue?vue&type=template&id=b9d4920a&scoped=true&"
import script from "./DoctorAgentPanel.vue?vue&type=script&lang=js&"
export * from "./DoctorAgentPanel.vue?vue&type=script&lang=js&"
import style0 from "./DoctorAgentPanel.vue?vue&type=style&index=0&id=b9d4920a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d4920a",
  null
  
)

export default component.exports